export default __webpack_public_path__ + "static/TheHumans-70d7f3bf899d2395fede7a5c028cb205.png";